import { useEffect, useState } from "react";
import { api, type Anchor, type HealthResponse, type ReadyResponse, type VerifyResponse } from "../api.ts";

export function Dashboard() {
  const [health, setHealth] = useState<HealthResponse | null>(null);
  const [ready, setReady] = useState<ReadyResponse | null>(null);
  const [verify, setVerify] = useState<VerifyResponse | null>(null);
  const [anchors, setAnchors] = useState<Anchor[]>([]);
  const [err, setErr] = useState("");

  async function load() {
    setErr("");
    try {
      setHealth(await api.health());
      setReady(await api.ready());
      setVerify(await api.verifyAudit());
      setAnchors((await api.listAnchors()).anchors ?? []);
    } catch (e) {
      setErr((e as Error).message);
    }
  }
  useEffect(() => {
    void load();
  }, []);

  const apiOk = health?.status === "ok";
  const ready_ok = ready?.status === "ready";

  return (
    <>
      <div className="row" style={{ marginBottom: 16 }}>
        <h2 style={{ margin: 0 }}>Overview</h2>
        <button className="ghost" onClick={() => void load()}>
          Refresh
        </button>
      </div>
      {err && <div className="err">{err}</div>}

      <div className="grid">
        <div className="stat">
          <div className="label">API</div>
          <div className="value">
            <span className={`badge ${apiOk ? "ok" : "bad"}`}>{health?.status ?? "-"}</span>
          </div>
        </div>
        <div className="stat">
          <div className="label">Readiness</div>
          <div className="value">
            <span className={`badge ${ready_ok ? "ok" : "bad"}`}>{ready?.status ?? "-"}</span>
          </div>
        </div>
        <div className="stat">
          <div className="label">Audit entries</div>
          <div className="value">{verify?.count ?? "-"}</div>
        </div>
        <div className="stat">
          <div className="label">Audit integrity</div>
          <div className="value">
            <span className={`badge ${verify ? "ok" : "bad"}`}>{verify ? "verified" : "-"}</span>
          </div>
        </div>
        <div className="stat">
          <div className="label">On-chain anchors</div>
          <div className="value">{anchors.length}</div>
        </div>
      </div>

      <div className="card">
        <h3>Readiness checks</h3>
        {ready ? (
          <table>
            <tbody>
              {Object.entries(ready.checks).map(([k, v]) => (
                <tr key={k}>
                  <td>{k}</td>
                  <td>
                    <span className={`badge ${v === "ok" ? "ok" : "bad"}`}>{v}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="muted">-</p>
        )}
      </div>

      <div className="card">
        <h3>Audit head</h3>
        {verify ? (
          <p className="mono small">
            {verify.count} entries · head <code>{verify.headHash.slice(0, 24)}…</code>
          </p>
        ) : (
          <p className="muted">-</p>
        )}
      </div>
    </>
  );
}
